<template>
	<div class="party-item-container-row">
		<div v-if="isRemovable" v-on:click="removeItem" class="party-item-remove-icon">
			<i class="fas fa-times"></i>
		</div>

		<i :class="'party-item-icon fas fa-'+faIcon" :style="iconColor ? 'color:'+iconColor+';':''"></i>

		<div class="party-row-cred-title" :class="{'party-item-is-waived': isWaived}" :style="color ? 'color:'+color+';':''">{{ title }}</div>

		<div v-if="!isProcessParty" class="party-row-price" :class="{'party-item-is-waived': isWaived}" :style="color ? 'color:'+color+';':''">
			{{ price ? formatPrice(price) : '-&nbsp;&nbsp;&nbsp;' }}
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PartyItemRow',
		components: {
		},
		props: {
			title: {
				type: String,
				default: 'Error',
			},
			color: {
				type: String,
				default: '',
			},
			iconColor: {
				type: String,
				default: '',
			},
			faIcon: {
				type: String,
				default: '',
			},
			price: {
				type: Number,
				default: null,
			},
			isWaived: {
				type: Boolean,
				default: false,
			},
			isRemovable: {
				type: Boolean,
				default: false,
			},
			removeDataObject: {
				type: Object,
				default: function() {
					return {};
				},
			},
			isProcessParty: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
			}
		},
		methods: {
			formatPrice(price) {
				const formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				});
				return formatter.format(price);
			},
			removeItem() {
				this.$emit('removeItem', this.removeDataObject);
			},
		},
	}
</script>

<style scoped>
	.party-item-container-row {
			display: flex;
			margin: .4em 0;
			align-items: baseline;
	}

	.party-item-icon {
			width: 1em;
			margin-right:.5em;
      color: var(--color-purple);
			text-align: center;
	}

	.party-row-cred-title, .party-row-price {
			font-family: 'Oswald', Tahoma, Verdana, sans-serif;
			font-weight: 700;
      color: var(--color-purple);
	}

	.party-row-price {
      flex-grow: 1;
			text-align: right;
			margin-right: .5em;
  }

	.party-item-is-waived {
			text-decoration: line-through;
      color: var(--color-orange);
	}

	.party-item-remove-icon {
      font-size: 1.5em;
			margin-right:15px;
      color: var(--color-red);
	}
</style>